import { createConfirmation } from "react-confirm";
import EncryptModal from "./EncryptModal";

export const showEncryptModal = createConfirmation(EncryptModal);
